import { DateTime } from "luxon";
import { Flex, Text } from "@radix-ui/themes";
import { FC } from "react";

interface DateTimeFieldRowProps {
  dateStr?: string | null;
  dateTime?: DateTime | null;
}

export const DateTimeFieldRow: FC<DateTimeFieldRowProps> = ({ dateStr, dateTime }) => {
  let targetDateTime: DateTime | null = null;

  if (dateTime) {
    targetDateTime = dateTime;
  } else if (dateStr) {
    targetDateTime = DateTime.fromISO(dateStr);
  }

  if (!targetDateTime) {
    return <div />;
  }

  return (
    <Flex align="center" justify="start" pl="1" pr="1">
      <Text size="1">{targetDateTime.toFormat("MMM dd, yyyy h:mm a")}</Text>
    </Flex>
  );
};
